import { apiUtils } from '../utils/apiUtils'


export default {
  get: function (name) {
    return fetch(apiUtils.integration + '/city/' + name, {
      method: 'GET'
    }).then((response) => response.json())
  },
}
